export default __webpack_public_path__ + "static/media/01.6141350c.jpg";